import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const ModalContent = styled.div`
  width: 480px;
  ${bp('sm')`
    width: 100%;
    box-sizing: border-box;
  `}

  p {
    margin: 0 0 20px;
    user-select: none;
    color: ${props => props.theme.palette.general.greyDark};
  }
`

export const ModalHeader = styled.h3`
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  position: absolute;
  width: 100%;
  left: 0;
  padding-bottom: 18px;
  padding-left: 20px;
  top: 0;
  box-sizing: border-box;
  pointer-events: none;
`

export const ModalAfterTitle = styled.div`
  margin-top: 40px;
  display: flex;

  span {
    display: block;
  }

  > div {
    p {
      font-weight: bold;
    }
  }
`

export const ModalFooter = styled.div<{hasTwoButtons?: boolean }>`
  height: 40px;

  > div {
    border-top: 1px solid ${props => props.theme.palette.general.greyLight};
    position: absolute;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px 10px 0 0;
    box-sizing: border-box;
    ${({ hasTwoButtons }) => hasTwoButtons && `
      justify-content: space-between;
      flex-wrap: wrap;
      padding-left: 10px;

      > button {
        margin: 10px;
      }
    `}
  }

  button {
    margin-right: 10px;
  }
`

export const ImageWrapper = styled.div`
  margin-right: 30px;
  width: 50%;

  img {
    width: 100%;
  }
`

export const InfoWrapper = styled.div`
  width: 50%;
`
